import React from "react";

import Hero from "components/Hero";

export default function Policies() {
	window.scrollTo(0, 0);
	document.title = "Policies || Jozini Municipality";

	return (
			<Hero
				subheading="Policies"
				title="Policies"
				description="Minima dolorum vero quas ullam exercitationem animi. Soluta dicta excepturi temporibus assumenda."
				backgroundImage={require("images/page-title.jpg")}
				hideAppointmentButton
			/>
	);
}
